export default __webpack_public_path__ + "static/media/step1.39ffd8a0.svg";